var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-search-box" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value",
        },
      ],
      staticClass: "trbo-a-search-box__input",
      attrs: {
        "aria-label": "Search",
        placeholder: _vm.$t("wizard.searchFor"),
      },
      domProps: { value: _vm.value },
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.submitSearch.apply(null, arguments)
        },
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.value = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "trbo-a-search-box__button",
        on: { click: _vm.onSubmitClear },
      },
      [
        !_vm.isSubmitted
          ? _c("icon", { attrs: { name: "search" } })
          : _c("icon", { attrs: { name: "close" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }